import { ReactNode } from 'react';

export const OffersPageShell = ({
    progressIndicator,
    mainContent,
    sidePanel
}: {
    progressIndicator: ReactNode;
    mainContent: ReactNode;
    sidePanel: ReactNode;
}) => (
    <div className="flex flex-col bg-structure-100 min-m:flex-row">
        <div className="flex grow basis-0 justify-center min-m:justify-end min-m:px-2xl">
            <div className="w-full max-w-[610px] space-y-xl pt-xl">
                {progressIndicator}
                {mainContent}
            </div>
        </div>
        <div className="min-m:grow min-m:basis-0 min-m:bg-primary-10">
            {sidePanel}
        </div>
    </div>
);
